
import React, { useEffect, useRef } from "react";
import { emphasize, styled } from '@mui/material/styles';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Chip from '@mui/material/Chip';
import HomeIcon from '@mui/icons-material/Home';
import IconButton from '@mui/material/IconButton';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';

import { MdBrandingWatermark } from "react-icons/md";
import { BiSolidCategoryAlt } from "react-icons/bi";
import Rating from '@mui/material/Rating';
import { MdFilterVintage } from "react-icons/md";
import { MdRateReview } from "react-icons/md";
import { BsPatchCheckFill } from "react-icons/bs";
import { useParams } from "react-router-dom";
import { useState } from "react";
import { fetchDataFromApi } from "../../utils/api";
import ProductZoom from '../../components/ProductZoom';
import './ProductDetails.css'
import UserAvatarImgComponent from "../../components/UserAvatarImgComponent";

//breadcrumb code
const StyledBreadcrumb = styled(Chip)(({ theme }) => {
    const backgroundColor =
        theme.palette.mode === 'light'
            ? theme.palette.grey[100]
            : theme.palette.grey[800];
    return {
        backgroundColor,
        height: theme.spacing(3),
        color: theme.palette.text.primary,
        fontWeight: theme.typography.fontWeightRegular,
        '&:hover, &:focus': {
            backgroundColor: emphasize(backgroundColor, 0.06),
        },
        '&:active': {
            boxShadow: theme.shadows[1],
            backgroundColor: emphasize(backgroundColor, 0.12),
        },
    };
});

const ProductDetails = () => {
    const [productData, setProductData] = useState([]);
    const [reviewsData, setreviewsData] = useState([]);
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState('');

    const { id } = useParams();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    useEffect(() => {
        window.scrollTo(0, 0);
        fetchDataFromApi(`/api/products/${id}`).then((res) => {
            setProductData(res);
        })

        fetchDataFromApi(`/api/productReviews?productId=${id}`).then((res) => {
            setreviewsData(res)
        })
    }, [id]);

    // Copy to clipboard function
    const copyToClipboard = async (text) => {
        try {
            await navigator.clipboard.writeText(text);
            setSnackbarMessage('Copied to clipboard!');
            setSnackbarOpen(true);
        } catch (err) {
            // Fallback for older browsers
            const textArea = document.createElement('textarea');
            textArea.value = text;
            textArea.style.position = 'fixed';
            textArea.style.opacity = '0';
            document.body.appendChild(textArea);
            textArea.select();
            try {
                document.execCommand('copy');
                setSnackbarMessage('Copied to clipboard!');
                setSnackbarOpen(true);
            } catch (fallbackErr) {
                setSnackbarMessage('Failed to copy');
                setSnackbarOpen(true);
            }
            document.body.removeChild(textArea);
        }
    };

    const handleSnackbarClose = () => {
        setSnackbarOpen(false);
    };

    // Reusable copy text component
    const CopyableText = ({ text, children, inline = false, style = {} }) => {
        if (!text) return children;
        
        return (
            <span style={{ position: 'relative', display: inline ? 'inline-flex' : 'flex', alignItems: 'center', ...style }}>
                {children}
                <IconButton 
                    size="small" 
                    onClick={() => copyToClipboard(text)}
                    style={{ 
                        marginLeft: '6px', 
                        padding: '2px',
                        minWidth: 'auto',
                        opacity: 0.7
                    }}
                    title={`Copy: ${text}`}
                >
                    <ContentCopyIcon fontSize="small" sx={{ fontSize: '14px' }} />
                </IconButton>
            </span>
        );
    };

    return (
        <>
            <div className="right-content w-100 productDetails">
                <div className="card shadow border-0 w-100 flex-row p-4">
                    <CopyableText text="Product View" inline>
                        <h5 className="mb-0">Product View</h5>
                    </CopyableText>
                    <Breadcrumbs aria-label="breadcrumb" className="ml-auto breadcrumbs_">
                        <StyledBreadcrumb
                            component="a"
                            href="#"
                            label="Dashboard"
                            icon={<HomeIcon fontSize="small" />}
                        />

                        <StyledBreadcrumb
                            label="Products"
                            component="a"
                            href="#"
                        />
                        <StyledBreadcrumb
                            label="Product View"
                        />
                    </Breadcrumbs>
                </div>

                <div className='card productDetailsSEction'>
                    <div className='row'>
                        <div className='col-md-5'>
                            <div className="sliderWrapper pt-3 pb-3 pl-4 pr-4">
                                <CopyableText text="Product Gallery">
                                    <h6 className="mb-4">Product Gallery</h6>
                                </CopyableText>
                                <ProductZoom images={productData?.images} discount={productData?.discount} />
                            </div>
                        </div>

                        <div className='col-md-7'>
                            <div className=" pt-3 pb-3 pl-4 pr-4">
                                <CopyableText text="Product Details">
                                    <h6 className="mb-4">Product Details</h6>
                                </CopyableText>

                                <CopyableText text={productData?.name}>
                                    <h4>{productData?.name}</h4>
                                </CopyableText>

                                <div className="productInfo mt-4">
                                    <div className="row mb-2">
                                        <div className="col-sm-3 d-flex align-items-center">
                                            <span className="icon"><MdBrandingWatermark /></span>
                                            <CopyableText text="Brand" inline>
                                                <span className="name">Brand</span>
                                            </CopyableText>
                                        </div>

                                        <div className="col-sm-9">
                                            :   <CopyableText text={productData?.brand} inline>
                                                <span>{productData?.brand}</span>
                                            </CopyableText>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-sm-3 d-flex align-items-center">
                                            <span className="icon"><BiSolidCategoryAlt /></span>
                                            <CopyableText text="Category" inline>
                                                <span className="name">Category</span>
                                            </CopyableText>
                                        </div>

                                        <div className="col-sm-9">
                                            : <CopyableText text={productData?.catName} inline>
                                                <span>{productData?.catName}</span>
                                            </CopyableText>
                                        </div>
                                    </div>

                                    {
                                        productData?.productRam?.length !== 0 &&
                                        <div className="row">
                                            <div className="col-sm-3 d-flex align-items-center">
                                                <span className="icon"><MdFilterVintage /></span>
                                                <CopyableText text="RAM" inline>
                                                    <span className="name">RAM</span>
                                                </CopyableText>
                                            </div>

                                            <div className="col-sm-9">
                                                : <span>
                                                    <div className="row">
                                                        <ul className="list list-inline tags sml">
                                                            {
                                                                productData?.productRam?.map((item, index) => {
                                                                    return (
                                                                        <li className="list-inline-item" key={index}>
                                                                            <CopyableText text={item} inline>
                                                                                <span>{item}</span>
                                                                            </CopyableText>
                                                                        </li>
                                                                    )
                                                                })
                                                            }
                                                        </ul>
                                                    </div>
                                                </span>
                                            </div>
                                        </div>
                                    }

                                    {
                                        productData?.size?.length !== 0 &&
                                        <div className="row">
                                            <div className="col-sm-3 d-flex align-items-center">
                                                <span className="icon"><MdFilterVintage /></span>
                                                <CopyableText text="SIZE" inline>
                                                    <span className="name">SIZE</span>
                                                </CopyableText>
                                            </div>

                                            <div className="col-sm-9">
                                                : <span>
                                                    <div className="row">
                                                        <ul className="list list-inline tags sml">
                                                            {
                                                                productData?.size?.map((item, index) => {
                                                                    return (
                                                                        <li className="list-inline-item" key={index}>
                                                                            <CopyableText text={item} inline>
                                                                                <span>{item}</span>
                                                                            </CopyableText>
                                                                        </li>
                                                                    )
                                                                })
                                                            }
                                                        </ul>
                                                    </div>
                                                </span>
                                            </div>
                                        </div>
                                    }
                                    {
                                        productData?.productWeight?.length !== 0 &&
                                        <div className="row">
                                            <div className="col-sm-3 d-flex align-items-center">
                                                <span className="icon"><MdFilterVintage /></span>
                                                <CopyableText text="Weight" inline>
                                                    <span className="name">Weight</span>
                                                </CopyableText>
                                            </div>

                                            <div className="col-sm-9">
                                                : <span>
                                                    <div className="row">
                                                        <ul className="list list-inline tags sml">
                                                            {
                                                                productData?.productWeight?.map((item, index) => {
                                                                    return (
                                                                        <li className="list-inline-item" key={index}>
                                                                            <CopyableText text={item} inline>
                                                                                <span>{item}</span>
                                                                            </CopyableText>
                                                                        </li>
                                                                    )
                                                                })
                                                            }
                                                        </ul>
                                                    </div>
                                                </span>
                                            </div>
                                        </div>
                                    }

                                    <div className="row">
                                        <div className="col-sm-3 d-flex align-items-center">
                                            <span className="icon"><MdRateReview /></span>
                                            <CopyableText text="Review" inline>
                                                <span className="name">Review</span>
                                            </CopyableText>
                                        </div>

                                        <div className="col-sm-9">
                                            : <CopyableText text={`(${reviewsData?.length}) Review`} inline>
                                                <span>({reviewsData?.length}) Review</span>
                                            </CopyableText>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-sm-3 d-flex align-items-center">
                                            <span className="icon"><BsPatchCheckFill /></span>
                                            <CopyableText text="Published" inline>
                                                <span className="name">Published</span>
                                            </CopyableText>
                                        </div>

                                        <div className="col-sm-9">
                                            : <CopyableText text={productData?.dateCreated} inline>
                                                <span>{productData?.dateCreated}</span>
                                            </CopyableText>
                                        </div>
                                    </div>

                                    {Array.isArray(productData?.specification) && productData.specification.length > 0 && (
                                        <table style={{ width: '100%', borderCollapse: 'collapse', marginTop: '1rem' }}>
                                            <thead>
                                                <tr style={{ backgroundColor: '#f5f5f5', textAlign: 'left' }}>
                                                    <th style={{ padding: '12px', borderBottom: '2px solid #ddd' }}>
                                                        <CopyableText text="Specification" inline>
                                                            Specification
                                                        </CopyableText>
                                                    </th>
                                                    <th style={{ padding: '12px', borderBottom: '2px solid #ddd' }}>
                                                        <CopyableText text="Details" inline>
                                                            Details
                                                        </CopyableText>
                                                    </th>
                                                    <th style={{ padding: '12px', borderBottom: '2px solid #ddd', width: '60px' }}>Actions</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {productData.specification.map((spec) => (
                                                    <tr key={spec.id || spec._id}>
                                                        <td style={{ padding: '10px', borderBottom: '1px solid #eee', fontWeight: 'bold' }}>
                                                            <CopyableText text={spec.key} inline>
                                                                {spec.key}
                                                            </CopyableText>
                                                        </td>
                                                        <td style={{ padding: '10px', borderBottom: '1px solid #eee' }}>
                                                            <CopyableText text={spec.value} inline>
                                                                {spec.value}
                                                            </CopyableText>
                                                        </td>
                                                        <td style={{ padding: '10px', borderBottom: '1px solid #eee', textAlign: 'center' }}>
                                                            <IconButton 
                                                                size="small" 
                                                                onClick={() => copyToClipboard(`${spec.key}: ${spec.value}`)}
                                                                title="Copy complete specification"
                                                                color="primary"
                                                            >
                                                                <ContentCopyIcon fontSize="small" />
                                                            </IconButton>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="p-4">
                        <CopyableText text="Product Description">
                            <h6 className="mt-4 mb-3">Product Description</h6>
                        </CopyableText>
                        <CopyableText text={productData?.description}>
                            <p>{productData?.description}</p>
                        </CopyableText>

                        {Array.isArray(productData?.additionalInfo) && productData.additionalInfo.length > 0 && (
                            <table style={{ width: '100%', borderCollapse: 'collapse', marginTop: '1rem' }}>
                                <thead>
                                    <tr style={{ backgroundColor: '#f9f9f9', textAlign: 'left' }}>
                                        <th style={{ padding: '10px', borderBottom: '2px solid #ccc' }}>
                                            <CopyableText text="Additional Info" inline>
                                                Additional Info
                                            </CopyableText>
                                        </th>
                                        <th style={{ padding: '10px', borderBottom: '2px solid #ccc' }}>
                                            <CopyableText text="Details" inline>
                                                Details
                                            </CopyableText>
                                        </th>
                                        <th style={{ padding: '10px', borderBottom: '2px solid #ccc', width: '60px' }}>Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {productData.additionalInfo.map((spec) => (
                                        <tr key={spec.id || spec._id}>
                                            <td style={{ padding: '10px', borderBottom: '1px solid #eee', fontWeight: 'bold' }}>
                                                <CopyableText text={spec.key} inline>
                                                    {spec.key}
                                                </CopyableText>
                                            </td>
                                            <td style={{ padding: '10px', borderBottom: '1px solid #eee' }}>
                                                <CopyableText text={spec.value} inline>
                                                    {spec.value}
                                                </CopyableText>
                                            </td>
                                            <td style={{ padding: '10px', borderBottom: '1px solid #eee', textAlign: 'center' }}>
                                                <IconButton 
                                                    size="small" 
                                                    onClick={() => copyToClipboard(`${spec.key}: ${spec.value}`)}
                                                    title="Copy complete additional info"
                                                    color="primary"
                                                >
                                                    <ContentCopyIcon fontSize="small" />
                                                </IconButton>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        )}

                        <br />
                        <br />

                        {
                            reviewsData?.length !== 0 &&
                            <>
                                <CopyableText text="Customer Reviews">
                                    <h6 className="mt-4 mb-4">Customer Reviews</h6>
                                </CopyableText>

                                <div className="reviewsSecrion">
                                    {
                                        reviewsData?.length !== 0 && reviewsData?.map((review, index) => {
                                            return (
                                                <div className="reviewsRow" key={index}>
                                                    <div className="row">
                                                        <div className="col-sm-7 d-flex">
                                                            <div className="d-flex flex-column">
                                                                <div className="userInfo d-flex align-items-center mb-3">
                                                                    <UserAvatarImgComponent
                                                                        name={review.customerName || ''}
                                                                        img={null}
                                                                        lg={true}
                                                                    />

                                                                    <div className="info pl-3">
                                                                        <CopyableText text={review?.customerName} inline>
                                                                            <h6>{review?.customerName}</h6>
                                                                        </CopyableText>
                                                                        <CopyableText text={review?.dateCreated} inline>
                                                                            <span>{review?.dateCreated}</span>
                                                                        </CopyableText>
                                                                    </div>
                                                                </div>

                                                                <Rating name="read-only" value={review?.customerRating} readOnly />
                                                            </div>
                                                        </div>

                                                        <CopyableText text={review?.review}>
                                                            <p className="mt-3">{review?.review}</p>
                                                        </CopyableText>
                                                    </div>
                                                </div>
                                            )
                                        })
                                    }
                                </div>
                            </>
                        }
                    </div>
                </div>

                {/* Snackbar for copy feedback */}
                <Snackbar
                    open={snackbarOpen}
                    autoHideDuration={2000}
                    onClose={handleSnackbarClose}
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                >
                    <Alert onClose={handleSnackbarClose} severity="success" sx={{ width: '100%' }}>
                        {snackbarMessage}
                    </Alert>
                </Snackbar>
            </div>
        </>
    )
}

export default ProductDetails;

